import {Btn, BtnLink, Container, Title, Wrap} from "./styled";

export const ContactLink = ({titleText, btnText, href}) => {
    return (
        <Container>
            <Wrap>
               <Title dangerouslySetInnerHTML={{ __html: titleText }}/>
               {href ? (
                   <BtnLink href={href}>
                       {btnText}
                   </BtnLink>
               ) : (
                   <Btn to='/'>
                       {btnText}
                   </Btn>
               )}
            </Wrap>
        </Container>
    )
}